import React, { useEffect } from 'react'
import { Box, Button } from '@material-ui/core'
import { SideBar } from '../../../components/side-bar'
import { navLinksProduct } from '../../../services/product'
import {
    attributeGroups
} from '../../../store/slices'
import { useAppDispatch } from '../../../store'
import { useSelector } from 'react-redux'
import { IAttributeGroup } from '../../../store/types'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'
import { getIdFromIRI } from '../../../services/_common/utils'
import { DataTable } from '../../../components/dataTable'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../constants'


export function AttributeGroupsPage(): JSX.Element {

    const dispatch = useAppDispatch()
    const fetchStatus = useSelector(attributeGroups.selectors.fetchStatus)
    const totalItems = useSelector(attributeGroups.selectors.totalItems)

    useEffect(() => {
        dispatch(attributeGroups.actions.fetch({pagination: false}))
    }, [])

    return (
        <Box display="flex">
            <SideBar navLinks={navLinksProduct}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={Link}
                    to={ROUTES.PRODUCT_ATTRIBUTE_GROUPS_CREATE}
                >
                    Создать
                </Button>
            </SideBar>
            <DataTable<IAttributeGroup, FetchCreatedAtParams & FetchCollectionParams>
                title={'Группы атрибуты'}
                urlPathEdit={'/product/attribute-groups/edit'}
                fetchProps={{
                    page: 1,
                    perPage: 20,
                }}
                fetchAction={attributeGroups.actions.fetch}
                selector={attributeGroups.selectors.selectAll}
                deleteAction={attributeGroups.actions.remove}
                mappingFunction={(attribute) => ({
                    id: getIdFromIRI(attribute.id),
                    name: attribute.name
                })}
                loading={fetchStatus.isFetching}
                columns={[
                    { field: 'id', headerName: 'ID', flex: 1, sortable: false, hide: true },
                    { field: 'name', headerName: 'Название', flex: 1, sortable: true }
                ]}
                rowCount={totalItems}
            >
            </DataTable>
        </Box>
    )
}